import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { images } from 'utils';

const CustomRadio = ({ label, selected, onClick }) => {
	return (
		<React.Fragment>
			<div
				id="CustomRadio"
				className={`p-3s mb-3s d-flex align-items-center pointer animate__animated animate__fadeIn ${selected ? 'selected' : ''}`}
				onClick={() => onClick && onClick()}
			>
				{selected ? (
					<img
						src={images.RadioChecked}
						alt="RadioChecked"
						style={{ height: 24 }}
						className="animate__animated animate__fadeIn"
					/>
				) : (
					<img
						src={images.RadioUnchecked}
						alt="RadioUnchecked"
						style={{ height: 24 }}
						className="animate__animated animate__fadeIn"
					/>
				)}
				<span className="ml-3 fs-14 fw-500">{label}</span>
			</div>
		</React.Fragment>
	);
};

CustomRadio.propTypes = {
	label: PropTypes.string,
	selected: PropTypes.bool,
	onClick: PropTypes.func,
};

export default memo(CustomRadio);
